import {Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Pipe({
  name: 'gpOrdinal',
  pure: false
})
export class CalendarOrdinalPipe implements PipeTransform {

  constructor(private translate: TranslateService) {
  }

  public transform(value: number): string {
    let suffix = '';
    if (!value || value < 1) {
      return value + suffix;
    }
    if (this.translate.currentLang === 'en-US') {
      const last = value % 10;
      const specialLast = value % 100;
      if (last === 1 && specialLast !== 11) {
        suffix = 'st';
      } else if (last === 2 && specialLast !== 12) {
        suffix = 'nd';
      } else if (last === 3 && specialLast !== 13) {
        suffix = 'rd';
      } else {
        suffix = 'th';
      }
    } else {
      suffix = value === 1 ? 'st' : 'th';
    }
    return value + this.translate.instant(`PAYROLL_PREPARE.${suffix}`);
  }
}
